import React from 'react';

import {BackendSourceOptions, discoveryTracker} from '@udemy/browse-event-tracking';

import {TopicCard} from '../topic-card/topic-card.react-component';
import {EnrichedSkills} from './enriched-skills.react-component';
import {useMarketingSplitCardsData} from './hooks/useLocaleContentfulData';

export const EnrichedSkillsContainer = () => {
    const {header, cards, hasData, isLoading} = useMarketingSplitCardsData();

    // Don't render if there's no data after loading is complete
    if (!isLoading && !hasData) {
        return null;
    }

    // Show skeleton cards while loading
    const displayCards = isLoading
        ? Array.from({length: 6}, () => ({title: undefined, url: '', image: {url: ''}}))
        : cards;

    const onClick = (card: {title?: string; url: string; image: {url: string}}, index: number) => {
        if (!card.title) return;
        discoveryTracker.trackDiscoveryItemClickEvent(
            {
                item: {
                    id: index,
                    title: card.title,
                    type: 'course_topic',
                },
            },
            {
                backendSource: 'discovery' as BackendSourceOptions,
                index: index,
                uiRegion: 'learn_essential_skills',
            },
        );
    };

    const onImpression = (
        card: {title?: string; url: string; image: {url: string}},
        index: number,
    ) => {
        if (!card.title) return;
        discoveryTracker.trackDiscoveryImpression(
            {
                item: {
                    id: index,
                    title: card.title,
                    type: 'course_topic',
                },
            },
            {
                backendSource: 'discovery' as BackendSourceOptions,
                index: index,
                uiRegion: 'learn_essential_skills',
            },
        );
    };

    return (
        <EnrichedSkills
            title={isLoading ? undefined : header?.headline}
            subtitle={isLoading ? undefined : header?.supportingText || undefined}
        >
            {displayCards.map((card, i: number) => (
                <TopicCard
                    key={`topic-card-${i}`}
                    headingElement="span"
                    title={card.title}
                    href={card.url}
                    num_enrollments={0} // GraphQL data doesn't have learners, using fallback
                    backgroundImageUrl={card.image?.url}
                    onClick={() => onClick(card, i)}
                    trackImpression={() => onImpression(card, i)}
                />
            ))}
        </EnrichedSkills>
    );
};
